export default function Footer() {
  return (
    <footer 
      className="relative bg-gradient-to-b from-[#0a0a1e] to-[#050510] py-12 px-4"
    >
      {/* Multi-color top border - 黄色、ピンク、水色、黄色、水色、紫、水色 */}
      <div className="absolute top-0 left-0 right-0 h-1 flex">
        <div className="flex-1 bg-[#fcb122]"></div>
        <div className="flex-1 bg-[#fc457e]"></div>
        <div className="flex-1 bg-[#44c4ff]"></div>
        <div className="flex-1 bg-[#fcb122]"></div>
        <div className="flex-1 bg-[#44c4ff]"></div>
        <div className="flex-1 bg-[#ad12f2]"></div>
        <div className="flex-1 bg-[#44c4ff]"></div>
      </div>
      
      <div className="container mx-auto max-w-6xl">
        <div className="text-center">
          <p className="text-[8px] md:text-sm text-white/70 mb-2 whitespace-nowrap">
            LIVE TOUR 2026 "Humor is Human"
          </p>
          <p className="text-[8px] md:text-sm text-white/70 whitespace-nowrap">
            © 2026 IRINO MIYU. All Rights Reserved.
          </p>
        </div>
      </div>

      {/* Multi-color bottom border - 黄色、ピンク、水色、黄色、水色、紫、水色 */}
      <div className="absolute bottom-0 left-0 right-0 h-1 flex">
        <div className="flex-1 bg-[#fcb122]"></div>
        <div className="flex-1 bg-[#fc457e]"></div>
        <div className="flex-1 bg-[#44c4ff]"></div>
        <div className="flex-1 bg-[#fcb122]"></div>
        <div className="flex-1 bg-[#44c4ff]"></div>
        <div className="flex-1 bg-[#ad12f2]"></div>
        <div className="flex-1 bg-[#44c4ff]"></div>
      </div>
    </footer>
  );
}